"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({
    /**
     * @deprecated I think this may be no longer used since we removed kickoff Quests...
     */
    subquestIdentifier: zod_1.z.string().uuid().optional(),
});
const dataSchema = zod_1.z.object({});
exports.default = new ItemDefinition_1.ItemDefinition("Subquest", configSchema, dataSchema, new validation_1.ValidatorPipeline("Subquest Config Validator", []), new validation_1.ValidatorPipeline("Subquest Data Validator", []));
//# sourceMappingURL=Subquest.js.map